import { Issue } from "@adsk/acc-issues-types";

export const isIssueVisibleInDraftState = (
  userOxygenId: string | null,
  issue: Issue
) => userOxygenId === issue.assignedTo || userOxygenId === issue.createdBy;

export const shouldWarnBeforeUnpublish = ({
  userOxygenId,
  canViewUnpublishedIssues,
  issues,
}: {
  userOxygenId: string | null;
  canViewUnpublishedIssues: boolean;
  issues: Issue[];
}) =>
  !canViewUnpublishedIssues &&
  issues.some(issue => !isIssueVisibleInDraftState(userOxygenId, issue));
